var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('generic-view',{attrs:{"title":"Mobile Phones","entity_name":"mobilePhone","headers":_vm.headers,"user_id":_vm.user_id,"driver_id":_vm.driver_id,"icon":"mdi-phone"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }